import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Modal, Form } from "react-bootstrap";
import { FaArrowRight } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import swal from "sweetalert";
import DOMPurify from "dompurify";
import Header from "../../include/header";

const Packageplanlist = ({ handleclick }) => {
  const [packagedata, setPackage] = useState([]);
  const [imagePath, setImagePath] = useState("");
  const [trigger, setTrigger] = useState(false);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const [counsellingForm, setCounsellingForm] = useState({
    username: "",
    email: "",
    mobile: "",
    students_of: "test",
  });

  const [errors, setErrors] = useState({
    username: false,
    email: false,
    mobile: false,
  });

  const [userId, setUserId] = useState(localStorage.getItem("user_id"));
  const packageId = localStorage.getItem("packageId");
  const navigate = useNavigate();

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    if (packageId) fetchPackageDetail();

    const handleStorageChange = () => {
      setUserId(localStorage.getItem("user_id"));
    };
    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [packageId]);

  const fetchPackageDetail = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/package-plan-list`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ package_cou_id: packageId, user_id: userId }),
        }
      );
      const data = await response.json();
      if (data.status === "1") {
        setPackage(data.data);
        setImagePath(data.imagePath);
      } else {
        setPackage([]);
      }
    } catch (err) {
      console.error("Error fetching package:", err);
    }
  };

  const getDiscountPercent = (amount, discount) => {
    if (!amount || !discount) return 0;
    return Math.round(((amount - discount) / amount) * 100);
  };

  const stripHTMLTags = (html) => {
    if (!html) return "";
    return DOMPurify.sanitize(html, { ALLOWED_TAGS: [] });
  };

  const handleEnroll = () => {
    setTrigger((prev) => !prev);
  };

  const handleSelectPlan = (item) => {
    localStorage.setItem("plan_id", item.id);
    navigate("/course-cart");
  };

  const handleCounsellingSubmit = async (e) => {
    e.preventDefault();

    const newErrors = {
      username: !counsellingForm.username,
      email:
        !counsellingForm.email || !/\S+@\S+\.\S+/.test(counsellingForm.email),
      mobile:
        !counsellingForm.mobile || !/^\d{10}$/.test(counsellingForm.mobile),
    };
    setErrors(newErrors);

    if (Object.values(newErrors).some((error) => error)) return;

    setLoading(true);
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/book-free-counselling`,
        counsellingForm
      );

      if (response.data.success === "1") {
        swal({
          title: "Success",
          text: "Your request has been submitted!",
          icon: "success",
          timer: 2000,
          buttons: false,
        });
        setCounsellingForm({
          username: "",
          email: "",
          mobile: "",
          students_of: "",
        });
        handleClose();
      } else {
        swal({
          title: "Error",
          text: response.data.message || "Something went wrong",
          icon: "error",
          timer: 2000,
          buttons: false,
        });
      }
    } catch (error) {
      console.error(error);
      swal("Error", "Failed to submit request", "error");
    }
    setLoading(false);
  };

  return (
    <>
      <section className="course_plan">
        <Container>
          <div className="py-5">
            <Row>
              <Col md={12}>
                <h2 className="text-center mt-5">Choose a plan for success</h2>
              </Col>
              <Header handleclick={trigger} />

              {packagedata.length > 0 ? (
                packagedata.map((item, index) => {
                  const today = new Date();
                  const endDate = new Date(item.end_date || today);
                  const isExpired = endDate < today;

                  return (
                    <Col
                      key={index}
                      lg={4}
                      md={6}
                      sm={6}
                      xs={12}
                      className="mb-4"
                    >
                      <Card className="plan_box shadow-sm mt-2 mt-md-4">
                        {imagePath && item.course_image && (
                          <Card.Img
                            variant="top"
                            src={`${imagePath}${item.course_image}`}
                            alt={item.course_name}
                          />
                        )}
                        <Card.Body>
                          {/* <Card.Title>{item.plan_title}</Card.Title>
                          <Card.Text>
                            {item.course_description?.substring(0, 80)}
                          </Card.Text> */}
                          <div className="plan_select">
                            <div className="coursName">
                              <span className="text-muted">
                                {item.course_name}
                              </span>
                            </div>
                            <div className="dicount_Plan">
                              <div className="plan_amount fw-bold">
                                <span className="totalAmount">
                                  ₹{item.discount_amount}
                                </span>
                                <span
                                  className="discount"
                                  style={{
                                    textDecoration: "line-through",
                                    color: "grey",
                                  }}
                                >
                                  ₹{item.amount}
                                </span>
                              </div>
                              <p className="off">
                                {getDiscountPercent(
                                  item.amount,
                                  item.discount_amount
                                )}
                                % off
                              </p>
                            </div>
                            <ul className="plan-benefits my-2">
                              {/* <p>{stripHTMLTags(item?.description || "")}</p> */}
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: DOMPurify.sanitize(
                                    item?.description || ""
                                  ),
                                }}
                              ></div>
                            </ul>
                          </div>

                          {/* ✅ Conditional Buttons */}
                          <div className="d-flex gap-2 flex-column">
                            {item.purchase_status === "active" ? (
                              <button
                                className="educate-btn sm me-2 w-100 d-flex justify-content-center gap-2 align-items-center mt-2 btn-success"
                                onClick={() => navigate("/dashboard")}
                              >
                                <span className="educate-btn__curve"></span>
                                View <FaArrowRight />
                              </button>
                            ) : item.purchase_status === "inactive" ? (
                              <button className="educate-btn sm me-2 w-100 d-flex justify-content-center gap-2 align-items-center mt-2 btn-warning">
                                <span className="educate-btn__curve"></span>
                                Pending <FaArrowRight />
                              </button>
                            ) : userId ? (
                              <button
                                className="educate-btn sm me-2 w-100 d-flex justify-content-center gap-2 align-items-center mt-2 btn-primary"
                                onClick={() => handleSelectPlan(item)}
                              >
                                <span className="educate-btn__curve"></span>
                                Select Plan <FaArrowRight />
                              </button>
                            ) : (
                              <button
                                className="educate-btn sm me-2 w-100 d-flex justify-content-center gap-2 align-items-center mt-2 btn-primary"
                                onClick={() => handleEnroll(item)}
                              >
                                <span className="educate-btn__curve"></span>
                                Enroll Now <FaArrowRight />
                              </button>
                            )}

                            <button
                              className="educate-btn book_btn sm w-100"
                              onClick={handleShow}
                            >
                              Book Free Counselling
                            </button>
                          </div>
                        </Card.Body>
                      </Card>
                    </Col>
                  );
                })
              ) : (
                <Col md={12}>
                  <div className="text-center py-4">
                    <p>No package plans available</p>
                  </div>
                </Col>
              )}
            </Row>
          </div>
        </Container>
      </section>

      <Header />

      {/* ✅ Book Free Counselling Modal */}
      <Modal
        show={show}
        onHide={handleClose}
        centered
        className="enquire_form"
        backdrop="static"
      >
        <button
          type="button"
          className="custom-close-btn"
          onClick={handleClose}
        >
          ×
        </button>
        <Modal.Body>
          <h5 className="text-center">Book Free Counselling</h5>
          <p className="text-center text-muted">
            Get a callback from us for all details or admission.
          </p>
          <Form onSubmit={handleCounsellingSubmit}>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="Full Name"
                maxLength={40}
                value={counsellingForm.username}
                onChange={(e) =>
                  setCounsellingForm({
                    ...counsellingForm,
                    username: e.target.value,
                  })
                }
                className={errors.username ? "is-invalid" : ""}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="email"
                placeholder="Email Address"
                maxLength={40}
                value={counsellingForm.email}
                onChange={(e) =>
                  setCounsellingForm({
                    ...counsellingForm,
                    email: e.target.value,
                  })
                }
                className={errors.email ? "is-invalid" : ""}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Control
                type="tel"
                placeholder="Mobile Number"
                inputMode="numeric"
                value={counsellingForm.mobile}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");
                  if (value.length <= 10)
                    setCounsellingForm({ ...counsellingForm, mobile: value });
                }}
                className={errors.mobile ? "is-invalid" : ""}
                maxLength={10}
              />
              {errors.mobile && (
                <div className="invalid-feedback">
                  Mobile number must be 10 digits
                </div>
              )}
            </Form.Group>
            <button
              className="educate-btn w-100"
              type="submit"
              disabled={loading}
            >
              <span className="educate-btn__curve"></span>
              {loading ? "Submitting..." : "Submit"}
            </button>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Packageplanlist;
